export enum BetSlipPaymentType {
    TOTAL = 'Total',
    MAX_GAIN = 'MaxGain',
    PER_COMBINATION = 'PerCombination',
}